import { Observable } from 'rxjs';
export abstract class DataProvider {
  abstract getGenerics(): Promise<any[]>;
  abstract getGenericsOthers(): Promise<any[]>;
  abstract getGenericsGrupos(): Promise<any[]>;
  abstract getFeaturedCategories(): Promise<any[]>;
  abstract getCategory(categoryGuid): Promise<any[]>;
  abstract getCategories(): Promise<any[]>;
  abstract getFeaturedProducts(): Promise<any[]>;
  abstract getProducts(categoryGuid): Promise<any[]>;
  abstract getBusiness(): Promise<any>;
  abstract getFeaturedProduct(productId: string): Promise<any>;
  abstract getProduct(categoryId: string, productId: string): Promise<any>;
  abstract getArticles(): Promise<any[]>;
  abstract getArticle(id: string): Promise<any[]>;
  abstract setUserId(id: string);
  abstract getGruposByGenerics(id: string);
  abstract getAlergenos(): Promise<any[]>;
  abstract getAllProducts(): Promise<any[]>;
  abstract saveOrder(cart, clientData, tipoPedido, fechaSolicitada);
  abstract crearAvisoEmail(cuerpoCorreo: any, destinatario: string, asunto: string, parametroCorreo: string): Observable<any>;
}
